<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/user_notices' }"
        >我的公告</el-breadcrumb-item
      >
      <el-breadcrumb-item>公告详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <h3>{{ notice.title }}</h3>
      <div class="flex-row-between font-12 mt-10">
        <span>发布者：{{ publisher }}</span>
        <span>
          {{ formatTime(notice.published_at) }}
        </span>
      </div>
      <p class="font-12">摘要：{{ notice.summary || '无' }}</p>
      <div
        class="ql-editor pl-0"
        v-if="notice.content"
        v-html="notice.content"
      ></div>
      <div
        class="mt-10 file-list"
        v-if="notice.files && notice.files.length > 0"
      >
        <h4>附件</h4>
        <div class="flex-row" v-for="file in notice.files">
          <a :href="host + file.url" target="_blank">{{ file.name }}</a>
          <span class="pointer" v-show="!isMobile()" @click="download(file)"
            >下载</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userNoticeDetail } from '@/service/getData'
import auth from '../../../util/auth'
import { noticeShow } from '../../../service/getData'
import { formatTime, isMobile } from '../../../util'
import { host } from '../../../config/env'
import download from 'downloadjs'
export default {
  data() {
    return {
      isMobile,
      formatTime,
      host,
      id: this.$route.params.id,
      notice: {
        user: {},
      },
    }
  },
  beforeRouteUpdate(to, from, next) {
    let toid = parseInt(to.params.id)
    if (toid != this.id) {
      this.id = toid
      setTimeout(this.getNotice, 50)
    }
    next()
  },
  created() {
    this.getNotice()
  },
  computed: {
    publisher() {
      if (this.notice.dealer_id == 0 && !auth.isPlatformUser()) {
        return '平台'
      } else {
        return this.notice.user.name
      }
    },
  },
  methods: {
    async getNotice() {
      let res = await noticeShow(this.id)
      if (res.code == 0) {
        this.notice = res.data
      }
    },
    download(file) {
      var x = new XMLHttpRequest()
      x.open('GET', this.host + file.url, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        download(e.target.response, file.name)
      }
      x.send()
    },
  },
}
</script>

<style scoped>
.file-list {
  padding-top: 20px;
  border-top: 1px solid #eee;
}
.file-list div {
  margin-top: 10px;
}

.file-list div span {
  margin-left: 12px;
  color: #999;
}
h4 {
  color: #888;
  font-size: 14px;
}
</style>